import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/Header';
import SlidingMenu from '../components/SlidingMenu';
import SideMenu from '../components/SlideMenu';

const MainLayout = () => {
  const [isSlidingMenuOpen, setSlidingMenuOpen] = useState<boolean>(false);
  const [isNarrow, setIsNarrow] = useState<boolean>(false);

  return (
    <div className="w-screen h-screen max-w-full">
      <Header openSlidingMenu={setSlidingMenuOpen} />
      <SlidingMenu isOpen={isSlidingMenuOpen} setSlidingMenuOpen={setSlidingMenuOpen} />

      <section className="flex flex-row sm:p-6 p-4 gap-6 w-full relative">
        <div className="hidden xl:flex">
          <SideMenu outputIsNarrot={(e) => setIsNarrow(e)} />
        </div>
        <div className={`w-full ${isNarrow ? 'xl:w-[calc(100%-112px)]' : 'xl:w-[calc(100%-288px)]'}`}>
          <Outlet />
        </div>
      </section>
    </div>
  );
};

export default MainLayout;
